export const bag = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M14 2.5A4.5 4.5 0 0 0 9.5 7H6.586l-.293.293-1.5 1.5-.277.277-.015.392-.5 13-.017.436.309.31 1.5 1.5.293.292h15.828l.293-.293 1.5-1.5.31-.309-.018-.436-.5-13-.015-.392-.277-.277-1.5-1.5L21.414 7H18.5A4.5 4.5 0 0 0 14 2.5ZM16.5 7a2.5 2.5 0 0 0-5 0h5Zm-7 2H7.414l-.93.93-.468 12.172.898.898h14.172l.898-.898-.468-12.172-.93-.93H9.5Z"
    fill="currentColor"
  />
);
